module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pulse-button-container"
  }, [_c('button', {
    staticClass: "pulse-button",
    style: (_vm.buttonStyles),
    on: {
      "click": function($event) {
        return _vm.showHomeScreen(true)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-caret-left"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27f40913", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27f40913"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/add-homescreen-button.vue
// module id = 800
// module chunks = 0